import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

function Paginator({
  totalRecords,
  data,
  recordPerPage,
  pageRange,
  onPageChange,
  simple = false,
  isCatalog = false,
  presentPage,
  id
}) {

  const [currentPage, setCurrentPage] = useState(1);

  function get_paged_data(pagenumber) {
    return data.filter((item, index) => {
      return (
        index >= pagenumber * recordPerPage - recordPerPage &&
        index < pagenumber * recordPerPage
      );
    });
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    var pdata = get_paged_data(pageNumber);
    onPageChange(pageNumber, pdata);
  };

  function redraw() {
    var ppage = Math.ceil(totalRecords / recordPerPage);
    if (ppage < currentPage && ppage > 0)
      handlePageChange(Math.ceil(totalRecords / recordPerPage));
    else handlePageChange(currentPage);
  }

  function handlePageChangeClick(e) {
    const selectedPage = e.selected + 1;
    setCurrentPage(selectedPage);
    let pdata = get_paged_data(selectedPage);
    onPageChange(selectedPage, pdata);
  }

  useEffect(() => {
    if (isCatalog) {
      handlePageChange(1);
    } else {
      redraw();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalRecords, recordPerPage]);
  return (
    <div id={id} className="tw-flex tw-items-center tw-justify-center tw-mt-4">
       {Math.ceil(totalRecords / recordPerPage) > 1 && recordPerPage <= totalRecords && (
      <div className = "tw-py-2">
      <ReactPaginate
        previousLabel={<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.35608 1.00012L1.35608 5.00012L5.35608 9.00012" stroke="#DFE1E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        }
        nextLabel={<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00342 1.00012L5.00342 5.00012L1.00342 9.00012" stroke="#253858" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        }
        nextLinkClassName="tw-h-8 tw-w-8 tw-block tw-flex tw-items-center tw-rounded"
        previousLinkClassName="tw-h-8 tw-w-8 tw-block tw-flex tw-items-center tw-rounded"
        previousClassName="aspect-sqaure"
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={Math.ceil(totalRecords / recordPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageChangeClick}
        containerClassName={`pagination tw-items-center tw-space-x-1 ${isCatalog ? "pagination-item-bg-blue":""}`} 
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
        renderOnZeroPageCount={null}  
        forcePage={isCatalog ? presentPage-1 : undefined}
      />
    </div>)}
    </div>
  
  );
}

export default Paginator;
